import React, { useState, useEffect } from "react";
import "react-dropdown/style.css";
import LayoutV2 from "containers/LayoutV2";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { TableDanhSach } from "./TableDanhSach";
import TaiSanCongTyApi from "service/taiSanCongTyApi";
export const TaiSanCongTy = () => {
  const [quyenDanhSach, setQuyenDanhSach] = useState(false);
  const [dataDanhSach, setDataDanhSach] = useState([]);

  const initSearch = {
    maTaiSan: "",
    kho: "0",
    soSanh: "=",
    giaTriTimKiem: "",
    pageIndex: 1,
    pageSize: 20,
  };

  const [dataSearch, setDataSearch] = useState(initSearch);

  const getQuyen = () => {
    TaiSanCongTyApi.PhanQuyen().then((response) => {
      if ((response.status = 200)) setQuyenDanhSach(response.data.taisancongty);
      console.log("response.dataresponse.dataresponse.data", response.data);
    });
  };

  const onSearch = () => {
    TaiSanCongTyApi.DanhSach(
      dataSearch.maTaiSan,
      dataSearch.kho,
      dataSearch.soSanh,
      dataSearch.giaTriTimKiem,
      dataSearch.pageIndex,
      dataSearch.pageSize,
    ).then((response) => {
      console.log("responseresponseresponse", response);
      setDataDanhSach(response.data);
    });
  };

  const handlePageChange = (pageNumber) => {
    console.log("pageNumber", pageNumber);
    dataSearch.pageIndex = pageNumber;
    setDataSearch(dataSearch);
    onSearch(dataSearch);
  };

  useEffect(() => {
    getQuyen();
    onSearch();
  }, [dataSearch, quyenDanhSach]);

  return (
    <LayoutV2>
      {quyenDanhSach && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Tài sản công ty</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop
                      onSearch={onSearch}
                      setDataSearch={setDataSearch}
                      dataSearch={dataSearch}
                    />
                    {/* <SearchBarMobile /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableDanhSach
            dataDanhSach={dataDanhSach}
            onSearch={onSearch}
            setDataSearch={setDataSearch}
            dataSearch={dataSearch}
            handlePageChange={handlePageChange}
          />
        </div>
      )}
      {quyenDanhSach === false && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Tài sản công ty</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
